import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { postLikeClicked } from "../actions";
import { bootstrapCompanyPosts, loadCompanyPosts, loadNextPosts } from "../../companies/actions";

type Post = WtdModels.Partial<
  WtdModels.Post,
  "id",
  {
    liked_status: WtdModels.Partial<WtdModels.LikedStatus, "state">;
  }
>;

export interface PostLikesState {
  [key: number]: boolean;
}

function initState(posts: Post[]) {
  return posts.reduce(
    (acc, post) => {
      acc[post.id] = post.liked_status.state || false;
      return acc;
    },
    {} as PostLikesState
  );
}

const postLikesReducer = withImmer(reducerWithInitialState<PostLikesState>({}))
  .cases([bootstrapCompanyPosts], (state, result) => {
    Object.assign(state, initState(result.posts));
    return state;
  })
  .cases([loadCompanyPosts.done, loadNextPosts.done], (state, { result }) => {
    Object.assign(state, initState(result.posts));
    return state;
  })
  .case(postLikeClicked.started, (state, postId) => {
    state[postId] = !state[postId];
    return state;
  })
  .case(postLikeClicked.failed, (state, { params: postId }) => {
    state[postId] = !state[postId];
    return state;
  });

export default postLikesReducer;



// WEBPACK FOOTER //
// ./frontend/src/post_likes/reducers/index.ts